import $S from 'theme/settings';
import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import debounce from 'lodash/debounce';
import {
  fetchTransferOrders,
  startAutoReload,
  stopAutoReload,
  clearTransferOrderList,
  setActiveStatus,
} from 'actions/transferOrderList';
import { fetchTransferStockLocations } from 'actions/transferStockLocations';
import { dateFormatter, objectSelector, sortByGivenKeys } from 'theme/utils';
import { fetchStockLocation } from 'actions/stockLocation';
import { fetchTransferStatuses } from 'actions/transferStatuses';
import { isDefined } from 'utils';
import { fetchCurrentStaff } from 'actions/staffs';

const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);

let _content = null;

const TransferOrderList = (props) => {
  const {
    fetchTransferOrders,
    startAutoReload,
    stopAutoReload,
    clearTransferOrderList,
    setActiveStatus,
    fetchTransferStockLocations,
    fetchStockLocation,
    stockLocation,
  } = props;
  const dispatch = useDispatch();

  const [orderDate, setOrderDate] = useState(undefined);
  const [barcode, setBarcode] = useState(undefined);
  const [sku, setSku] = useState(undefined);
  const [orderNumber, setOrderNumber] = useState(undefined);
  const [packageNumber, setPackageNumber] = useState(undefined);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [transferFilterBarRef, setTransferFilterBarRef] = useState(null);
  const [scrollEvent, setScrollEvent] = useState(null);
  const localCurrentStaff = localStorage.getItem('localCurrentStaff')
  const localRemoteId =
    isDefined(localCurrentStaff) &&
    isDefined(localCurrentStaff.current_store) &&
    localCurrentStaff.current_store.remote_id
  const usedStorage = JSON.parse(localStorage.getItem('usedStorage'));
  const erpCode = localRemoteId || usedStorage.remote_id
  const isBrandKoton = $A.BRAND === 'Koton'
  const destinationFilter = isBrandKoton ? { destination__erp_code: erpCode } : {}

  const setDebouncedQuery = debounce((value) => setQueryObject(value), 400);

  let statuses = getStatuses();

  useEffect(() => {
    setTransferFilterBarRef(React.createRef());
    setScrollEvent(toggleFilterBarStyle());
  }, []);

  const [statusId, setStatusId] = useState(
    props.activeStatusId ||
    (statuses.length && statuses[0].id !== 0 && statuses[0].id) ||
    JSON.parse(localStorage.getItem('localActiveStatusId'))
  );

  localStorage.setItem(
    'localActiveStatusId',
    JSON.stringify(statuses.length && statuses[0].id)
  );

  const [queryObject, setQueryObject] = useState({
    state:
      props.activeStatusId ||
      (statuses.length && statuses[0].id !== 0 && statuses[0].id) ||
      statusId,
    ...destinationFilter
  });

  function toggleFilterBarStyle() {
    if (transferFilterBarRef !== null && transferFilterBarRef.current) {
      const transferFilterSticky =
        window.scrollY > transferFilterBarRef.current.offsetTop;
      transferFilterSticky === true
        ? transferFilterBarRef.current.classList.add('sticky-property')
        : transferFilterBarRef.current.classList.remove('sticky-property');
    }
  }

  useEffect(() => {
    fetchTransferOrders();
    fetchStockLocation();
    window.addEventListener('scroll', scrollEvent);
    if ($S.transferOrderListAutoReload.active) {
      startAutoReload($S.transferOrderListAutoReload.ms);
    }
    return () => {
      stopAutoReload();
      clearTransferOrderList();
      window.removeEventListener('scroll', this.scrollEvent);
    };
  }, []);

  useEffect(() => {
    if (stockLocation !== null && stockLocation.id !== null) {
      fetchTransferStockLocations(stockLocation.id);
    }
  }, [stockLocation]);

  useEffect(() => {
    dispatch(fetchTransferStatuses());
    dispatch(fetchCurrentStaff())
  }, []);

  const rowSelection = {
    onRowSelection: (selectedRowKeys) => {
      setSelectedRowKeys(selectedRowKeys);
    },
  };

  const onTabChange = (id) => {
    setStatusId(id);
    setActiveStatus(id);
    filterTable(id);
  };

  function getStatuses() {
    const { transferStockLocations, transferStatuses } = props;

    const statuses =
      transferStatuses &&
      transferStatuses
        .sort((a, b) => {
          if (a.enum_value === b.enum_value) return a.id - b.id;
          return a.enum_value - b.enum_value;
        })
        .filter((item) => item && item.content_type.model === 'transferorder')
        .map((item) => ({
          ...item,
          count: objectSelector(
            transferStockLocations,
            `${[0]}.${[item.id]}`,
            0
          ),
        }));

    const filteredStatuses = sortByGivenKeys(
      statuses,
      $S.transferOrderListDefaultStatusesToShow,
      'enum_value'
    ).filter(({ enum_value }) =>
      $S.transferOrderListDefaultStatusesToShow.includes(enum_value)
    );

    return filteredStatuses || [];
  }
  const [rerenderFilter, setRerenderFilter] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'orderNumber') {
      setOrderNumber(value);
    } else if (name === 'packageNumber') {
      setPackageNumber(value);
    } else if (name === 'firstName') {
      setFirstName(value);
    } else if (name === 'lastName') {
      setLastName(value);
    } else if (name === 'barcode') {
      setBarcode(value);
    } else if (name === 'sku') {
      setSku(value);
    }
    setRerenderFilter(true);
  };

  useEffect(() => {
    if (rerenderFilter) {
      filterTable();
      setRerenderFilter(false);
    }
  }, [rerenderFilter]);

  const filterTable = (id) => {
    const order__date = orderDate && dateFormatter(orderDate, 'DD/MM/YYYY');

    setDebouncedQuery({
      state: id !== null ? id : statusId,
      product__barcode: barcode,
      order__date: order__date,
      customer__first_name: firstName,
      customer__last_name: lastName,
      product__sku: sku,
      order__number: orderNumber,
      number: packageNumber,
      ...destinationFilter
    });
  };

  const handleOrderDate = (orderDate) => {
    setOrderDate(orderDate);
    setRerenderFilter(true);
  };

  const getEnumValue = () => {
    const statuses = getStatuses();
    const status = statuses.find((status) => status.id === statusId);
    return status && status.enum_value;
  };

  return (
    _content &&
    _content({
      props,
      orderDate,
      barcode,
      sku,
      orderNumber,
      packageNumber,
      firstName,
      lastName,
      queryObject,
      statusId,
      selectedRowKeys,
      transferFilterBarRef,
      scrollEvent,
      rowSelection,
      erpCode,
      onTabChange,
      getStatuses,
      filterTable,
      getEnumValue,
      handleChange,
      handleOrderDate,
    })
  );
};

const mapStateToProps = (state) => ({
  transferStatuses: state.transferStatuses.transferStatuses,
  pending: state.transferStatuses.pending || state.transferOrderList.pending,
  transferStockLocations: state.transferStockLocations.transferStockLocations,
  transferOrders: state.transferOrderList.transferOrders,
  activeStatusId: state.transferOrderList.activeStatusId,
  stockLocation: state.stockLocation.stockLocation,
});

const mapDispatchToProps = {
  fetchTransferOrders,
  startAutoReload,
  stopAutoReload,
  clearTransferOrderList,
  setActiveStatus,
  fetchTransferStockLocations,
  fetchStockLocation,
};

export default function (content) {
  _content = content;
  return connect(mapStateToProps, mapDispatchToProps)(TransferOrderList);
}



// WEBPACK FOOTER //
// ./src/_pageContainers/oms/TransferOrderList/main/index.js